import { createFunctionManager2 } from "./functionManager"

export const hitManager = createFunctionManager2<GeometricShape, Point2d, boolean>();